import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { mapSourceToTorRulesFormValues } from "./mapTorRulesToFormValues";
import type { TorRulesFormValues, TorRulesHydrationSource } from "./types";

type UseHydrateTorRulesProps = {
  source?: TorRulesHydrationSource;
};

export const useHydrateTorRules = (props: UseHydrateTorRulesProps) => {
  const { source } = props;
  const { reset } = useFormContext<TorRulesFormValues>();
  const hasHydratedRef = useRef(false);

  const torRules = source?.torRules;
  const torRuleCondition = source?.torRuleCondition;

  useEffect(() => {
    if (hasHydratedRef.current || !torRules?.length) return;

    hasHydratedRef.current = true;
    reset(mapSourceToTorRulesFormValues({ torRules, torRuleCondition }), { keepDefaultValues: false });
  }, [reset, torRuleCondition, torRules]);
};
